// Product rendering and interactions
import { getProducts } from '../core/store.js';
import { addItemToCart } from './cart.js';

export function renderProducts(containerSelector = '.product-container') {
    const products = getProducts();
    const productContainer = document.querySelector(containerSelector);

    if (!productContainer || !products) return;

    productContainer.classList.add("hidden"); // Hide products while loading
    productContainer.innerHTML = ""; // Clear existing products

    if (products.length > 0) {
        const fragment = document.createDocumentFragment();

        products.forEach(product => {
            const card = createProductCard(product);
            fragment.appendChild(card);
        });

        productContainer.appendChild(fragment);
        productContainer.classList.remove("hidden");
    }
}

function createProductCard(product) {
    const card = document.createElement("div");
    card.className = "card";

    // Image
    const img = document.createElement("img");
    img.src = product.image;
    img.alt = product.description || "Product Image";
    card.appendChild(img);

    // Title
    const title = document.createElement("h2");
    title.textContent = product.title || "Product title";
    card.appendChild(title);

    const productInfoContainer = document.createElement("div");
    productInfoContainer.className = "product-info-container";

    // Price
    const price = document.createElement("p");
    price.textContent = `£${product.price}`;
    price.classList.add("price");
    productInfoContainer.appendChild(price);

    // Size container
    const sizeContainer = document.createElement("div");
    sizeContainer.className = "size-container";

    const sizeMap = {
        Small: "S",
        Medium: "M",
        Large: "L",
        "Extra Large": "XL"
    };

    let selectedSize = null;

    // Create size buttons
    product.variants.forEach((variant) => {
        const sizeButton = document.createElement("button");
        sizeButton.textContent = sizeMap[variant.title];
        sizeButton.className = "size-button";

        // Disable the button if not available
        if (!variant.available) {
            sizeButton.disabled = true;
            sizeButton.classList.add("disabled");
            sizeButton.title = `${variant.title} is out of stock`;
        }

        // Handle size button click
        sizeButton.addEventListener("click", () => {
            // Clear previously selected button
            sizeContainer
                .querySelectorAll(".size-button")
                .forEach((btn) => btn.classList.remove("selected"));
            sizeButton.classList.add("selected");
            selectedSize = variant.title; // Update selected size
        });

        sizeContainer.appendChild(sizeButton);
    });

    productInfoContainer.appendChild(sizeContainer);

    // Add to cart button
    const button = document.createElement("button");
    button.textContent = "Add to Cart";
    button.className = "add-to-cart";

    // Handle add to cart
    button.addEventListener("click", () => {
        if (!selectedSize) {
            alert("Please select a size before adding to the cart.");
            return;
        }
        addItemToCart(product, selectedSize);
    });

    productInfoContainer.appendChild(button);
    card.appendChild(productInfoContainer);

    return card;
}